import type { PhylloGender, PhylloUserAnalyticsAudienceData } from '@round/api';
import { toDecimalPoint } from '@round/utils';
import countries from 'utility/countries';

const TOP_MARKETS_COUNT = 3;

const genderLabels: Record<PhylloGender, string> = {
    FEMALE: 'F',
    MALE: 'M',
    OTHERS: 'O',
};

export const getGenderSplit = (audience: PhylloUserAnalyticsAudienceData | undefined): string | null => {
    const distribution = audience?.gender_age_distribution;
    if (!distribution?.length) {
        return null;
    }

    const totals = distribution.reduce<Partial<Record<PhylloGender, number>>>((acc, { gender, value }) => {
        acc[gender] = (acc[gender] ?? 0) + value;
        return acc;
    }, {});

    return (Object.keys(genderLabels) as PhylloGender[])
        .filter((gender) => typeof totals[gender] === 'number')
        .map((gender) => `${genderLabels[gender]} ${toDecimalPoint(totals[gender] ?? 0, 0)}%`)
        .join(' / ');
};

export const getTopMarkets = (audience: PhylloUserAnalyticsAudienceData | undefined): string | null => {
    const countryValues = audience?.countries;
    if (!countryValues?.length) {
        return null;
    }

    return [...countryValues]
        .sort((a, b) => b.value - a.value)
        .slice(0, TOP_MARKETS_COUNT)
        .map(({ code, value }) => `${countries[code] ?? code} ${toDecimalPoint(value, 1)}%`)
        .join(', ');
};
